module.exports = __webpack_public_path__ + "static/media/voix3.6c6b4bca.ogg";